// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2uGl8","footer":"App_footer__3BnF-","sea":"App_sea__3GnJx","love":"App_love__IJqOk","cloud":"App_cloud__2YVtA","blocks":"App_blocks__mFtF8"};